import { ResourceType } from '@repo/api-gw-sdk';

export const ObjectStorageResourceTypes: ResourceType[] = [
  ResourceType.AwsS3,
  ResourceType.GcpCloudStorageBucket,
];

export const objectStoreName = (resourceType: ResourceType) =>
  resourceType === ResourceType.AwsS3 ? 'S3' : 'GCS';

export const sourceStorageSizeHelp = (resourceType: ResourceType) =>
  ObjectStorageResourceTypes.includes(resourceType)
    ? "Total size of all objects in the bucket. This can include objects Eon doesn't back up."
    : "The resource's current size in your cloud account - one point in time, not a history. This can include data Eon doesn't back up.";

export const eonSnapshotSizeHelp = (resourceType: ResourceType) =>
  `Everything Eon stores for this resource: the full snapshot plus every incremental still kept. It covers your whole retention window rather than one point in time, so it grows with the backup frequency and retention set in the backup policy.${
    ObjectStorageResourceTypes.includes(resourceType)
      ? ` Eon backs up objects only if they're the current version in the ${objectStoreName(resourceType)} Standard storage class and they meet your filtering criteria, if applicable.`
      : ''
  }`;
